import './publicPath'

const Vue = window.Vue
Vue.component('spotlightreviews', () => import('./app/spotlightreviews.vue'))
Vue.component('articlerating', () => import('./app/articlerating.vue'))


